import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

export const TAGS_QUERY_KEY = ["tags"] as const;

export type ListTagsQuery = {
  include_deleted?: boolean;
};

export function useTags(params: ListTagsQuery = {}) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...TAGS_QUERY_KEY, params],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/tags", {
        params: { query: params },
      });
      if (error !== undefined) {
        throw new Error("Failed to list tags");
      }
      return data;
    },
  });
}
